// This import cannot be shortened without creating circular dependencies.
import { OasysNodeModelForm } from '@app/page-components/app/canvas/node-forms';
import {
  DesignModuleNodeProps,
  IconClass,
  NodeTypeName,
  OasysObjectConfig
} from '@app/types';
import BaseNodeModel from '../BaseNodeModel';

/** Make calls to OASYS. */
export class OasysNodeModel extends BaseNodeModel<OasysObjectConfig> {
  constructor(
    nodeName = 'UNTITLED_NODE',
    x = 0,
    y = 0,
    props: DesignModuleNodeProps<OasysObjectConfig> | null = null,
    id = null
  ) {
    super(nodeName, x, y, null, id);
    this.props.nodeTypeName = NodeTypeName.oasys;
    this.props.iconClass = IconClass.bot;
    this.props.colorClass = 'yellowgreen';
    this.applyProps(props);
  }

  getConfigViews() {
    return [
      <OasysNodeModelForm key="form" object={this} />
    ];
  }
}
